<script>
export default {
  emits: ['pageChange'],
  props: {
    pagination: {
      type: Object,
      validator: (value) => {
        const fields = ['pageSize', 'totalPages', 'totalElements']
        return fields.every((field) => value[field] !== undefined && value[field] !== null)
      }
    }
  }
}
</script>

<template>
  <el-pagination
    class="sedap-table-pagination"
    layout="prev, pager, next"
    :total="pagination.totalElements"
    :page-size="pagination.pageSize"
    :page-count="pagination.totalPages"
    hide-on-single-page
    @current-change="$emit('pageChange', $event)"
  />
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Tables/Pagination/Pagination.vue